export async function createMonoInvoice(packId) {
  const base =
    process.env.REACT_APP_API_URL ||
    "http://localhost:3001";

  const auth = JSON.parse(localStorage.getItem("auth") || "null");
  const token = auth?.token;
  if (!token) throw new Error("No auth token");

  const res = await fetch(`${base}/api/pay/mono/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ packId }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || `HTTP ${res.status}`);
  return data; // { invoiceId, pageUrl }
}
